import { sm } from "src/styles/utility";
import tw from "src/utils/tw";
import { useMainOffset } from "../../utils/useMainOffset";

export default function Content(props) {
  const mainOffset = useMainOffset();

  let offsetTop = mainOffset;

  if (props.additionalOffset) {
    offsetTop += props.additionalOffset;
  }

  return (
    <div
      className={tw(
        "flex",
        "m-auto",
        "max-w-xl",
        "flex-col",
        "md:overflow-hidden",
        // "sm:block",
        props.className
      )}
      css={{
        height: `calc(100vh - ${offsetTop}px)`,
        [`@media(${sm})`]: {
          height: "auto",
        },
      }}
    >
      {props.children}
    </div>
  );
}
